
import { useSelector  } from 'react-redux';

import { getDatawin } from '../reducers'
import { getFetchPanelVisibility } from '../reducers/datawin'

export default function useDatawinFetchPanelVisibility() {
    const datawin = useSelector(state => getDatawin(state.data));
    return getFetchPanelVisibility(datawin);
}
